import { Quad } from '@dealpoint/api-models'
import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'

// eslint-disable-next-line import/no-cycle
import { RootState } from './types'

export interface ISelectedTextState {
  keyTermId?: string
  page?: number
  quads?: Quad[]
  text: string
}

const initialState: ISelectedTextState = {
  text: null,
}

const slice = createSlice({
  name: 'selectedText',
  initialState,
  reducers: {
    add(state, action: PayloadAction<ISelectedTextState>) {
      const { page, quads, text } = action.payload
      state.page = page
      state.quads = quads
      state.text = text
    },
    remove(state) {
      state.keyTermId = null
      state.page = null
      state.quads = null
      state.text = null
    },
    setKeyTermId(state, action: PayloadAction<string>) {
      state.keyTermId = action.payload
    },
  },
})

// Helpers

// Actions
export const { add: setSelectedText, remove: removeSelectedText, setKeyTermId } = slice.actions

// Selectors
const selectRoot = (state: RootState) => state.selectedText
export const selectSelectedText = createSelector(selectRoot, (selectedText) => selectedText)

// Reduce
export default slice.reducer
